import {
    IconHome,
    IconSwitch, IconPigMoney, IconMoodSadSquint, IconBuildingBank,
    IconNews, IconCreditCard, IconMessage, IconCalendarPlus,
    IconTooltip, IconAd2, IconNotification, IconQuestionMark,
    IconSchool, IconUser, IconMicroscope, IconStars, IconSitemap,
    IconFolder, IconZoomMoney, IconDiscount, IconBooks, IconRobotFace,
    IconGauge, IconNotes, IconCalendarStats, IconPresentationAnalytics,
    IconFileAnalytics
} from '@tabler/icons-react'

const sidebarURLs = () => {
    return [
        { label: "Administracion", link: "/admin/administracion", requiredPermision: "administracion", },
        {
            label: "Academico",
            initiallyOpened: true,
            requiredPermision: "academico",
            link: "/admin/academico",
        },
        {
            label: "Ventas",
            requiredPermision: "ventas",
            link: "/admin/ventas",
        },
        { label: "Marketing", link: "/admin/marketing", requiredPermision: "marketing", },
        { label: "Moderacion", link: "/admin/moderacion", requiredPermision: "moderacion", },
        { label: "Soporte", link: "/admin/soporte", requiredPermision: "soporte", },
        { label: "Dirección", link: "/admin/direccion", requiredPermision: "direccion", },
    ];
};

export const ROLE_SECTIONS = {
    administracion: {
        label: "Administración",
        icon: <IconGauge size={14} strokeWidth={1.8} />,
        basePath: "/admin/administracion",
        items: [
            { title: "Dashboard", href: "", icon: <IconHome size={14} strokeWidth={1.8} /> },
            { title: "Usuarios", text: 'Revisar y ajustar información de los usuarios', href: "usuarios", icon: <IconSwitch size={14} strokeWidth={1.8} /> },
            { title: "Ingresos", text: 'Visualizar la información relacionada a ingresos por inscripciones.', href: "ingresos", icon: <IconPigMoney size={14} strokeWidth={1.8} /> },
            { title: "Egresos", text: 'Visualizar la información pagos a realizar.', href: "egresos", icon: <IconMoodSadSquint size={14} strokeWidth={1.8} /> },
            { title: "Cuentas bancarias", text: 'Habilitar o deshabilitar cuentas. Crear nuevas cuentas bancarias disponibles.', href: "cuentas-bancarias", icon: <IconBuildingBank size={14} strokeWidth={1.8} /> },
            { title: "Sponsors", href: "sponsors", text: 'Habilitar o deshabilitar sponsors. Crear nuevos sponsors.', icon: <IconNews size={14} strokeWidth={1.8} /> },
            { title: "Cuotas", href: "cobros", text: 'Establecer cuotas como pagadas o pendientes.', icon: <IconCreditCard size={14} strokeWidth={1.8} /> },
        ],
    },
    academico: {
        label: "Académico",
        icon: <IconNotes size={14} strokeWidth={1.8} />,
        basePath: "/admin/academico",
        items: [
            { title: "Dashboard", href: "", icon: <IconHome size={14} strokeWidth={1.8} /> },
            {
                text: 'Crear capacitaciones, diplomados, cursos, clases.',
                title: "Unidades Académicas", href: "unidades-academicas", icon: <IconSchool size={14} strokeWidth={1.8} />
            },
            { title: "Usuarios", text: 'Ver, crear o editar usuarios .', href: "usuarios", icon: <IconUser size={14} strokeWidth={1.8} /> },
            { title: "Especialidades", text: 'Generar nuevas especialidades o editarlas', href: "especialidades", icon: <IconMicroscope size={14} strokeWidth={1.8} /> },
            { title: "Valoraciones", text: 'Revisar las valoraciones de las clases', href: "valoraciones", icon: <IconStars size={14} strokeWidth={1.8} /> },
            { title: "Planes de suscripción", text: 'Creación y edición de las características y precios', href: "planes-de-suscripcion", icon: <IconSitemap size={14} strokeWidth={1.8} /> },
            { title: "Biblioteca", text: 'Crear o editar el contenido de las suscripciones', href: "biblioteca-de-contenido", icon: <IconFolder size={14} strokeWidth={1.8} /> },
        ],
    },
    ventas: {
        label: "Ventas",
        icon: <IconCalendarStats size={14} strokeWidth={1.8} />,
        basePath: "/admin/ventas",
        items: [
            { title: "Dashboard", href: "", icon: <IconHome size={14} strokeWidth={1.8} /> },


            {
                title: "Precios",
                text: "Modificar el monto en pesos y dolares de las unidades académicas existentes.",
                href: "precios", icon: <IconZoomMoney size={14} strokeWidth={1.8} />
            },
            {
                title: "Descuentos",
                text: 'Generar descuentos para las unidades académicas.',
                href: "descuentos", icon: <IconDiscount size={14} strokeWidth={1.8} />
            },
            {
                title: "Inscripciones",
                text: 'Aquí encontrarás todas las solicitudes de inscripción a capacitaciones de FORVET.',
                href: "pagos-ingresados", icon: <IconSchool size={14} strokeWidth={1.8} />
            },
            {
                title: "Suscripciones",
                text: 'Aquí encontrarás todas las solicitudes de suscripciones.',
                href: "suscripciones", icon: <IconBooks size={14} strokeWidth={1.8} />
            },
            {
                title: "Mensajes automáticos",
                text: 'Aquí podrás utilizar el BOT para enviar mensajes automáticos a tus contactos.',

                href: "mensajes-en-masa", icon: <IconRobotFace size={14} strokeWidth={1.8} />
            },
            {
                title: "Prospectos",
                text: 'Contactos que mostraron interés (bot, formularios, consultas, etc.)',
                href: "prospectos", icon: <IconUser size={14} strokeWidth={1.8} />
            },
        ],
    },
    marketing: {
        label: "Marketing",
        icon: <IconPresentationAnalytics size={14} strokeWidth={1.8} />,
        basePath: "/admin/marketing",
        items: [
            { title: "Dashboard", href: "", icon: <IconHome size={14} strokeWidth={1.8} /> },

            {
                text: "Generar nuevas entradas para el campus y web ventas.",
                title: "Novedades", href: "novedades", icon: <IconNews size={14} strokeWidth={1.8} />
            },
            {
                text: 'Recepción y lectura de testimonios.',
                title: "Testimonios", href: "testimonios", icon: <IconMessage size={14} strokeWidth={1.8} />
            },
            {
                text: 'Generar eventos en calendario.',
                title: "Calendario", href: "calendario", icon: <IconCalendarPlus size={14} strokeWidth={1.8} />
            },
            {
                text: 'Crear nuevos mensajes y recomendados.',

                title: "Consejos", href: "consejos", icon: <IconTooltip size={14} strokeWidth={1.8} />
            },
            {
                text: 'Incorporar o editar oportunidades disponibles.',
                title: "Oportunidades", href: "oportunidades", icon: <IconAd2 size={14} strokeWidth={1.8} />
            },
            {
                text: 'Incorporar o editar notificaciones disponibles.',
                title: "Notificaciones", href: "notificaciones", icon: <IconNotification size={14} strokeWidth={1.8} />
            },
            {
                title: 'Preguntas Frecuentes',
                title: "Preguntas Frecuentes", href: "preguntas-frecuentes", icon: <IconQuestionMark size={14} strokeWidth={1.8} />
            },
        ],
    },
    moderacion: {
        label: "Moderación",
        icon: <IconFileAnalytics size={14} strokeWidth={1.8} />,
        basePath: "/admin/moderacion",
        items: [
            { title: "Dashboard", href: "", icon: <IconHome size={14} strokeWidth={1.8} /> },
            { title: "Estructuras", text: 'Ver clases por unidad académica. Editar moderadores y links de zoom.', href: "estructuras", icon: <IconSchool size={14} strokeWidth={1.8} /> },
            { title: "Clases", text: 'Buscar clases segun fecha, unidades académicas o profesores.', href: "clases", icon: <IconSchool size={14} strokeWidth={1.8} /> },
            { title: "Usuarios", text: 'Cargar información personal a los usuarios', href: "usuarios", icon: <IconUser size={14} strokeWidth={1.8} /> },
        ],
    },
};

export default sidebarURLs;
